import { useAssetFormDataParser } from "./useAssetFormParser";

export default useAssetFormDataParser;
